/**
 * created by wang lei
 xxxxx页面
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../../../../base/BaseComponent";
import {DatePicker, Radio} from 'antd';
import moment from "moment"

const {RangePicker} = DatePicker;

export default class Sta_Date extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            selectDateConfig: {
                "null": {
                    title: "空",
                    key: "0",
                    startTime: '0',
                    endTime: '0',
                },
                today: {
                    title: "今天",
                    key: "today",
                    startTime: moment().startOf("day").valueOf(),
                    endTime: moment().endOf('day').valueOf(),
                },
                yesterday: {
                    title: "昨天",
                    key: "yesterday",
                    startTime: moment().day(moment().day() - 1).startOf('day').valueOf(),
                    endTime: moment().day(moment().day() - 1).endOf('day').valueOf(),
                },
                thisWeek: {
                    title: "本周",
                    key: "thisWeek",
                    startTime: moment().startOf("week").valueOf(),
                    endTime: moment().endOf('week').valueOf(),
                },
                lastWeek: {
                    title: "上周",
                    key: "lastWeek",
                    startTime: moment().week(moment().week() - 1).startOf('week').valueOf(),
                    endTime: moment().week(moment().week() - 1).endOf('week').valueOf(),
                },
                thisMonth: {
                    title: "本月",
                    key: "thisMonth",
                    startTime: moment().startOf("month").valueOf(),
                    endTime: moment().endOf('month').valueOf(),
                },
                lastMonth: {
                    title: "上月",
                    key: "lastMonth",
                    startTime: moment().month(moment().month() - 1).startOf('month').valueOf(),
                    endTime: moment().month(moment().month() - 1).endOf('month').valueOf(),
                },
            },
            // params: {
            //     startTime:null,
            //     endTime: null,
            // },
            defaultKey: "",
            key: "",
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.setDefault()
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.getKeyByTime(nextProps.value);
    }

    // 加载默认架构
    setDefault = () => {
        const {onChange, labelCode} = this.props;
        this.setSelectNode();
        this.setDefaultTime((date) => {
            if ((date?.startTime || date?.startTime === null) && (date?.endTime || date?.endTime === null)) {
                this.onChangeTime(date, () => {
                    // 查询默认数据
                    onChange({fun: "onSearchDefault"})
                });
            }
        });
    };

    // 选中时间并回填到表单区域
    onChangeTime = (date, call) => {
        const {onChange, labelCode} = this.props;
        if ((date?.startTime || date?.startTime === null) && (date?.endTime || date?.endTime === null)) {
            // 将默认日期回填到表单区域，然后需要查询默认数据
            onChange({labelCode, val: [date.startTime, date.endTime], call})
        }
    };

    // 页面加载后设置默认选中的时间
    setDefaultTime = (call) => {
        const {config = {}} = this.props;
        const {selectDateConfig = {}} = config;
        const {defaultKey = {}} = selectDateConfig;
        if (defaultKey !== this.state.defaultKey) {
            this.state.defaultKey = defaultKey;
            this.state.key = defaultKey;
            let dateConfig = this.state.selectDateConfig?.[defaultKey];
            let startTime = dateConfig?.startTime;
            let endTime = dateConfig?.endTime;
            let newTime = {startTime, endTime};
            // this.state.params = newTime;
            call && call(newTime)
        }
    };

    // 根据key设置展现层数据
    setInputByKey = (call) => {
        let {key} = this.state;
        let dateConfig = this.state.selectDateConfig?.[key];
        let startTime = dateConfig?.startTime;
        let endTime = dateConfig?.endTime;
        let newTime = {startTime, endTime};
        // this.state.params = newTime;
        call && call(newTime)
    };

    setSelectNode = () => {
        const {config = {}} = this.props;
        const {selectDateConfig = {}} = config;
        let selectNode = this.forMatSelectNode(selectDateConfig);
        this.setState({selectNode})
    };

    // 切换
    onSelect = e => {
        let {config,onChange} = this.props
        let key = e.target.value;
        this.state.key = key;
        this.setInputByKey((date) => {
            // 回填数据到上层表单
            this.onChangeTime(date, () => {
                if (config?.onChangeCallFun) {
                    onChange({fun: config.onChangeCallFun})
                }
            })
        })
    };

    // 手动设置时间区间回调
    rangePickerOnChange = (date, dateString) => {
        let {config,onChange} =this.props;
        console.log(this.props.sameDay,'this.props.sameDay')
        let startTime,endTime;
        if(this.props.sameDay){

            startTime = date[0]._d.setHours(0, 0, 0, 0);
            endTime = date[1]._d.setHours(23, 59, 59);
        }else{

            startTime = date[0].valueOf();
            endTime = date[1].valueOf();
        }


        let newTime = {startTime, endTime};
        // this.state.params = newTime;
        // 根据当前选中时间回显卡片
        this.getKeyByTime(this.props.value);
        // 回填数据到上层表单
        this.onChangeTime(newTime, () => {
            if (config?.onChangeCallFun) {
                onChange({fun: config.onChangeCallFun})
            }
        })
    };

    forMatSelectNode = (selectDateConfig) => {
        let selectNode = [];
        if (selectDateConfig?.selectConfig?.length) {
            selectDateConfig.selectConfig.forEach(item => {
                if (this.state.selectDateConfig[item]) {
                    selectNode.push(this.state.selectDateConfig[item])
                }
            })
        }
        return selectNode
    };

    // 根据当前选中的时间回显卡片切换选中
    getKeyByTime = (value) => {
        let {selectDateConfig} = this.state;
        let startTime = value[0];
        let endTime = value[1];
        let key = "";
        for (let i in selectDateConfig) {
            let thisT = selectDateConfig[i];
            let sTime = thisT?.startTime;
            let eTime = thisT?.endTime;
            if (sTime === startTime && eTime === endTime) {
                key = i;
                break;
            }
        }
        if (key != this.state.key) {
            this.setState({key});
        }
    };
    timeFormatMoment = (time) => {
        if(time && time.toString && time.toString()?.length > 10) {
            return moment(time)
        }
        return null
    }
    render() {
        const {size, placeholder, config, value = [null, null]} = this.props;
        let {key} = this.state;
        const {style = {}} = config;
        let startTime = this.timeFormatMoment(value[0]);
        let endTime = this.timeFormatMoment(value[1]);
        return (
            <div style={{...style}}>
                {
                    this.state.selectNode?.length ? (
                        <Radio.Group
                            value={key}
                            // defaultValue={this.state.defaultKey}
                            style={{marginRight: 24}}
                            size={size}
                            onChange={this.onSelect}
                        >
                            {
                                this.state.selectNode.map(item => {
                                    let title = item?.title;
                                    let key = item?.key;
                                    return <Radio.Button value={key} key={key}>{title}</Radio.Button>
                                })
                            }
                        </Radio.Group>
                    ) : ""
                }
                <RangePicker
                    value={[startTime, endTime]}
                    placeholder={placeholder}
                    allowClear={false}
                    size={size}
                    onChange={this.rangePickerOnChange}
                    dateFormat='YYYY-MM-DD'
                />
            </div>
        )
    }

}